import GenericErrorModal from './GenericErrorModal';

export * from './GenericErrorModal';

export default GenericErrorModal;
